import { FC } from "react";
import { ClipPath, Defs, G, Path, Rect, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdCheck: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 18 18" fill="none" {...props}>
    <G clipPath="url(#clip0_1918_3076)">
      <Path
        d="M17.7364 2.65394C17.3849 2.30245 16.8151 2.30245 16.4636 2.65394L5.681 13.4366L1.53636 9.29197C1.1849 8.94047 0.615085 8.94051 0.263558 9.29197C-0.0879341 9.64342 -0.0879341 10.2132 0.263558 10.5647L5.0446 15.3457C5.39595 15.6972 5.96618 15.6969 6.31739 15.3457L17.7364 3.92674C18.0878 3.57528 18.0878 3.00543 17.7364 2.65394Z"
        fill="currentColor"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1918_3076">
        <Rect width="18" height="18" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default PdCheck;
